export default {"src":"/_next/static/media/cart-new.ea65ef76.svg","height":21,"width":21};